import React from 'react';
import classNames from 'classnames';
import { abbrevNumber } from '../../common/utils';
import { ABBREV_DECIMALS, NOT_AVAILABLE_LABEL } from '../../common/constants';
var NumericLabel = function (_a) {
    var value = _a.value, percentage = _a.percentage, _b = _a.decimals, decimals = _b === void 0 ? ABBREV_DECIMALS : _b, _c = _a.units, units = _c === void 0 ? '' : _c, _d = _a.showSign, showSign = _d === void 0 ? false : _d, className = _a.className, _e = _a.abbreviate, abbreviate = _e === void 0 ? false : _e, _f = _a.inverted, inverted = _f === void 0 ? false : _f;
    return (React.createElement("span", { className: classNames('numericLabel', className, { inverted: inverted }) }, value !== undefined ?
        "" + (showSign && value > 0 ? '+' : '') + (abbreviate ? abbrevNumber(value, decimals) : value) + (percentage ? '(' + abbrevNumber(percentage, decimals) + '%)' : '') + units
        : NOT_AVAILABLE_LABEL));
};
export default NumericLabel;
//# sourceMappingURL=NumericLabel.js.map